import styled from "styled-components"
import {label1, label2, label3, label4, caption, smallCaption, para, LabelProps, ParaProps} from "./css/labels"
import {WorkSansBold} from "../global/fonts"
import {brand} from "../global/colors"

// Used for large buttons
export const Label1 = styled.span<LabelProps>`
  ${label1}
`

export const Label2 = styled.span<LabelProps>`
  ${label2}
`

export const Label3 = styled.span<LabelProps>`
  ${label3}
`

export const Label4 = styled.span<LabelProps>`
  ${label4}
`

export const Caption = styled.p<LabelProps>`
  ${caption}
`

export const SmallCaption = styled.span<LabelProps>`
  ${smallCaption}
`

export const Strong = styled.strong`
  font-weight: 400;
  ${WorkSansBold}
`
// Default body size, Para for desktop, Caption for mobile
export const Para = styled.p<ParaProps>`
  ${para}
`

interface TabProps extends LabelProps {
  selected?: boolean
}
export const Tab = styled<TabProps>(Label3)`
  padding: 0 8px 4px;
  margin: 0 3px;
  font-weight: ${(props: TabProps) => (props.selected ? "bold" : "normal")};
  ${(props: TabProps) => (props.selected ? `border-bottom: 5px solid ${brand.default};` : "")}
  cursor: pointer;
  text-transform: uppercase;
`
